<template>
    <div class="yh-page">
        <el-card>
            <el-collapse v-model="activeNames">
            <el-collapse-item title="基础信息" name="1">
            <el-form ref="form" :model="form" :validate-on-rule-change="false" label-position="right"
                label-width="160px" >
                <div class="container">
                    <div class="left">
                        

                        <el-divider content-position="left">基础信息</el-divider>
                        <el-col :span="15">
                            <el-form-item label="转让人">
                                <el-input type="text" v-model="form.member_name" style="width: 48%;" disabled />
                            </el-form-item>
                        </el-col>
                        <el-col :span="15">
                            <el-form-item label="接收人">
                                <el-input type="text" v-model="form.recipient_name" style="width: 48%;" disabled />
                            </el-form-item>
                        </el-col>
                        <el-col :span="15">
                            <el-form-item label="船舶名">
                                <el-input type="text" v-model="form.ship_name" style="width: 48%;" disabled />
                            </el-form-item>
                        </el-col>
                        <el-col :span="15">
                            <el-form-item label="新船名">
                                <el-input type="text" v-model="form.new_ship_name" style="width: 48%;" disabled/>
                            </el-form-item>
                        </el-col>
                        
                        <el-col :span="15">
                            <el-form-item label="可转让金额">
                                <el-input type="text" v-model="form.ship_balance" style="width: 48%;" disabled />
                            </el-form-item>
                        </el-col>

                        <el-col :span="15">
                            <el-form-item label="转让金额">
                                <el-input type="text" v-model="form.balance" style="width: 48%;" :disabled="isEdit"/>
                            </el-form-item>
                        </el-col>

                        <el-col :span="15">
                            <el-form-item label="业务归属部门">
                                <el-input  v-model="form.department" style="width: 48%;" disabled />
                            </el-form-item>
                        </el-col>


                        <el-col :span="18">
                            <el-form-item label="创建人">
                                <el-input type="text" v-model="form.creator_name" style="width: 48%;" disabled />
                            </el-form-item>
                        </el-col>
                        <el-col :span="18">
                            <!-- 身份证明文件 -->
                            <el-form-item label="申请文件" prop="attachments">
                            <attachment-list 
                                object-type="member.accounttransfer" :object-id="form.id" :file-list="file_list"
                                :attachment-name="attachment_name"
                                @removed="loadFileList('member.accounttransfer', form.id)"></attachment-list>
                            <el-button type="primary" size="small" @click="handleUpload" class="ml-2">上传</el-button>
                            </el-form-item>
                        </el-col>
                        <el-col :span="18">
                            <el-form-item label="审批意见">
                                <el-input type="text" v-model="form.refuse_reason" style="width: 48%;" disabled />
                            </el-form-item>
                        </el-col>
                    

                    </div>
                </div>
            </el-form>
            <!--创建按钮-->
            <div class="btn-box">
                <el-button type="primary" @click="updateTransferInfo" v-if="opera_type ==='UpdateTransferApply'">确认修改</el-button>
                <!-- <el-button type="primary" @click="handleSuccess" v-if="opera_type ==='TransferApply'">审核通过</el-button> -->
                <el-button type="primary" @click="SuggestionVisible = true" v-if="opera_type ==='TransferApply'">前往审核</el-button>
            </div>
            </el-collapse-item>
            <el-collapse-item title="相关文书" name="2">
                        <el-col>
                            <file-sign-list :attachments="file_list" object_type="member.accounttransfer" :object_id="form.customer"></file-sign-list>
                         </el-col>
            </el-collapse-item>
            <upload-dialog ref="upload" :object-name="form.ship_name" :file-type-list="file_type_list"
                object-type="member.accounttransfer" :object-id="form.id" :append-to-body="true"
                :default-issue-date.sync="default_issue_date" :ship-list="shipList" :customer-list="customerList"
                @appended="handleAppended" @uploaded="loadFileList('member.accounttransfer', form.id)">
            </upload-dialog>
            <el-dialog :visible.sync="SuggestionVisible" width="50%">
                <el-form ref="refuse_reason" :model="refuse_reason" label-width="120px">
                <el-form-item label="审批意见" width="50%">
                    <el-input type="textarea"  :rows="10" v-model="refuse_reason"></el-input>
                </el-form-item>
                </el-form>
                <span slot="footer" class="dialog-footer">
                <el-button type="success" @click="handleSuccess">审核通过</el-button>
                <el-button type="warning" @click="addMessage">审核不通过</el-button>
                </span>
            </el-dialog>
        </el-collapse>
        </el-card>
    </div>
</template>

<script>

import {applyMember,transferSuccess,rejectTransferApply,getTransferInfo,updateTransfer} from '@/api/member'
import UploadDialog from "@/components/UploadDialog"
import { fetchFileList } from "@/utils"
import { fetchFileTypeList } from '@/api/common'
import FileSignList from '@/components/FileSignListDetail'
import AttachmentList from "@/components/AttachmentList"




export default {
    name: "shipApplyDetail",
    components: {
        UploadDialog,
        AttachmentList,
        FileSignList

    },
    computed: {
        attachment_name: function () {
        let name = this.form.ship_name
        return (name + ".zip");
        }
    },
    data() {
        return {
            ship_name:"",
            member:"",
            creator:"",
            apply_time:"",
            default_issue_date: '',
            file_type_list: [],
            file_list: [],
            shipList:[],
            customerList:[],
            isEdit:true,
            is_member:true,
            form:{},
            activeNames: ["1", "2"],
            apply_info:{},
            opera_type:"",
            SuggestionVisible:false,
            refuse_reason:"",
            loadingText: '正在加载数据，请稍等...',
        };
    },

    methods: { 
        updateTransferInfo(){
            if (this.form.balance > this.form.ship_balance){
                this.$error_message("转让金额不能超过可转让金额!")
                return
            }

            updateTransfer({"id":this.id,'balance':this.form.balance}).then(resp => {
                this.$message({
                    type: 'success',
                    message: '修改成功!'
                    })
                    this.$router.push({ name: 'transferApplyList' }) 
                })
                .catch(error => {
                    this.loading = false
                    this.$message.error(error)
                })
        },
        getData(id){
            getTransferInfo({"id":id}).then(resp => {
                this.form = resp   
                let customer_obj = {"id":this.form.recipient_id,"name":this.form.recipient_name}
                this.customerList.push(customer_obj)
                let ship_obj = {"id":this.form.ship,"name":this.form.ship_name}
                this.shipList.push(ship_obj)
                if (this.form.new_ship){
                    this.shipList.push({"id":this.form.new_ship,"name":this.form.new_ship_name})
                }
                })
                .catch(error => {
                    this.loading = false
                    this.$message.error(error)
                })
        },
        handleAppended(fileList) {
            this.file_list = this.file_list.concat(fileList)
            },
        loadFileList(object_type, object_id) {
        fetchFileList(object_type, object_id, this.file_type_list)
          .then(res => {
            this.file_list = res.file_list;
            this.file_list.forEach(item => {
              this.$set(item, 'checked', true)
            })
            // this.default_issue_date = res.def_issue_date;
            // this.default_expire_date = res.def_expire_date;
          })
          .catch(error => {
            this.$error_message(error);
          });
      },
        handleUpload() {
            this.$refs.upload.handleOpen()
            },
        handleSubmit() {
            this.$confirm('是否核对会员资料并且通过审核?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
                    }).then(() => {
                transferSuccess({ id: this.form.id })
                .then(res => {
                    this.$message.success(res)
                })
                .catch(err => {
                    this.$error_message(err)
                })
            }).catch(() => {
                this.$message({
                type: 'info',
                message: '已取消审核'
                });
            });
            },
        addMessage(){
            var msg = '是否拒绝该申请？'
            this.$confirm(msg, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'info'
            }).then(() => {
                rejectTransferApply({'id':this.form.id,refuse_reason:this.refuse_reason})
                .then(() => {
                    this.$message({
                    type: 'success',
                    message: '拒绝成功!'
                    })
                    this.$router.push({ name: 'transferApplyList' }) 
                })
                .catch(error => {
                    this.$message.error(error)
                })
            })
        },
        handleReject() {
            this.SuggestionVisible = true
        },
        handleSuccess() {
            var msg = '是否通过该申请？'
            this.$confirm(msg, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'info'
            }).then(() => {
                transferSuccess({'id':this.form.id, 'reason':this.refuse_reason})
                .then(() => {
                    this.$message({
                    type: 'success',
                    message: '通过成功!'
                    })
                    this.$router.push({ name: 'transferApplyList' })   
                })
                .catch(error => {
                    this.$message.error(error)
                })
            })
        },
        loadData() {
            this.getData(this.id)
            console.log(this.form)
            if (this.opear_type  !== 'ApplySuccess'){
                this.loadFileList('member.accounttransfer', this.id)
            }
            
            let p0 = fetchFileTypeList({ file_type: "cc|bc|sc" })
            Promise.all([p0])
                .then(res => {
 
                this.file_type_list = res[0]

                })
                .catch(error => {
                this.loading = false
                this.$message.error(error)
                })
                },
        
     
    },
    beforeRouteLeave(to, from, next) {
        if (to.name != 'transferApplyList') {
            window.localStorage.removeItem('query')
        }
        next()
    },
    created() {
        this.opera_type = this.$route.query.type
        this.id = this.$route.query.id
        if (this.opera_type==='UpdateTransferApply'){
            this.isEdit = false
        }
        
       
        this.loadData()
        // console.log(this.id )
    },
};
</script>

